import { render, staticRenderFns } from "./FeatureFlagCard.vue?vue&type=template&id=9dc8c686&scoped=true&lang=pug"
import script from "./FeatureFlagCard.vue?vue&type=script&lang=ts"
export * from "./FeatureFlagCard.vue?vue&type=script&lang=ts"
import style0 from "./FeatureFlagCard.vue?vue&type=style&index=0&id=9dc8c686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc8c686",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCardText,VChip,VCol,VIcon,VRow,VSwitch})
